/**
 * Where the page's own <Header> goes when a pharmacy module is framed by the
 * bank tabs and the module strip.
 *
 * WHY A SLOT AND NOT A MOVE. Every page in the app draws its own <Header
 * crumbs={…}> as its first element, because the crumbs are the page's to
 * decide. Inside PharmacyModuleStrips that header lands in the RIGHT-HAND
 * COLUMN, beside the module strip, so the bar with the logo, the bell and the
 * account menu starts 210px in and the strip runs up past it.
 *
 * Reagan, 2026-09-29: the header belongs across the top, always.
 *
 * Rewriting forty-seven pages to stop rendering their own header — and adding
 * a second way to pass crumbs — is a lot of blast radius for a layout
 * decision. Instead the strips layout offers a DOM node at the top, and Header
 * portals into it when one is on offer. The page keeps rendering <Header>
 * exactly as it does everywhere else; only where the node lands changes.
 *
 * Every other route provides no slot, so Header renders in place and nothing
 * outside pharmacy is touched.
 */
import { createContext, useContext } from 'react';

export const PharmacyHeaderSlot = createContext<HTMLElement | null>(null);

/** The node to portal the header into, or null to render it where it sits. */
export function usePharmacyHeaderSlot(): HTMLElement | null {
  return useContext(PharmacyHeaderSlot);
}
